module.exports = __webpack_public_path__ + "static/media/home_health_programme.b031a99c.png";